module.exports = __webpack_public_path__ + "img/default-avatar.3b563931.png";